var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { staticStyle: { "overflow-y": "hidden" }, attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.verDetalle,
              expression: "!verDetalle"
            }
          ],
          attrs: { titulo: "Editar Vehículo" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.verDetalle,
                  expression: "!verDetalle"
                }
              ],
              staticClass: "btnClass",
              staticStyle: { height: "75% !important" },
              attrs: { color: "#ff6c00" },
              on: {
                click: function($event) {
                  _vm.confirm = true
                }
              }
            },
            [_c("span", [_vm._v("Guardar Cambios")])]
          )
        ],
        1
      ),
      _c("CabeceraModal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.verDetalle,
            expression: "verDetalle"
          }
        ],
        attrs: { titulo: "Ver Vehículo" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": 400 },
          model: {
            value: _vm.confirm,
            callback: function($$v) {
              _vm.confirm = $$v
            },
            expression: "confirm"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  staticStyle: { "font-size": "17px" },
                  attrs: { dark: "", color: "primary" }
                },
                [_vm._v("\n        Guardar Cambios\n      ")]
              ),
              _c("divider"),
              _c("v-card-text", [
                _c("div", { staticStyle: { width: "100%" } }, [
                  _c("div", [
                    _vm._v(
                      "\n            Los cambios serán aplicados\n          "
                    )
                  ]),
                  _c("br"),
                  _c("div", [_vm._v("¿Desea continuar?")])
                ])
              ]),
              _c("divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "white", small: "" },
                      on: {
                        click: function($event) {
                          _vm.confirm = false
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "#526da5" } }, [
                        _vm._v("Cancelar")
                      ])
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "#526da5", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.sendData()
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v("Aceptar")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("br"),
      _c(
        "v-card",
        {
          staticClass: "card",
          staticStyle: { width: "70%", height: "auto", "overflow-y": "auto" }
        },
        [
          _c("v-text-field", {
            attrs: { label: "Patente", readonly: "", disabled: _vm.verDetalle },
            model: {
              value: _vm.detalleSeleccionado.patente_vehiculo,
              callback: function($$v) {
                _vm.$set(_vm.detalleSeleccionado, "patente_vehiculo", $$v)
              },
              expression: "detalleSeleccionado.patente_vehiculo"
            }
          }),
          _c("v-text-field", {
            attrs: { label: "Flota", readonly: "", disabled: _vm.verDetalle },
            model: {
              value: _vm.detalleSeleccionado.__nom_flota,
              callback: function($$v) {
                _vm.$set(_vm.detalleSeleccionado, "__nom_flota", $$v)
              },
              expression: "detalleSeleccionado.__nom_flota"
            }
          }),
          _c("v-switch", {
            attrs: {
              color: "#FDEF68",
              label:
                _vm.detalleSeleccionado.peajes.toString() == "SI"
                  ? "Activo"
                  : "Inactivo",
              readonly: _vm.verDetalle,
              inset: ""
            },
            on: {
              change: function($event) {
                return _vm.changeEstado()
              }
            },
            model: {
              value: _vm.switchActivo,
              callback: function($$v) {
                _vm.switchActivo = $$v
              },
              expression: "switchActivo"
            }
          }),
          _c("v-autocomplete", {
            attrs: {
              disabled: _vm.verDetalle,
              label: "Tipo Vehículo",
              items: _vm.tipoVehiculos,
              "item-text": "nombre",
              "item-value": "nombre"
            },
            model: {
              value: _vm.detalleSeleccionado.__desc_tipo_vehiculo,
              callback: function($$v) {
                _vm.$set(_vm.detalleSeleccionado, "__desc_tipo_vehiculo", $$v)
              },
              expression: "detalleSeleccionado.__desc_tipo_vehiculo"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }